








































































import { BillingModeEnum } from "@/lib/enum/billing-mode.enum";
import { ContractBillingTypeEnum } from "@/lib/enum/contract-billing-type.enum";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { emailRuleNullable } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { IBillingProfile } from "@/models/banking-information.entity";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
  filters: {}
})
export default class BillingProfileForm extends Vue {
  readonly ContractBillingTypeEnum = ContractBillingTypeEnum;
  readonly BillingModeEnum = BillingModeEnum;
  readonly CurrencyEnum = CurrencyEnum;

  @Prop()
  value!: IBillingProfile;

  get email() {
    return this.value.email;
  }

  set email(mail: string | null) {
    this.value.email = mail || null;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get emailRuleNullable() {
    return [emailRuleNullable()];
  }

  get billingTypeItems() {
    return [
      {
        text: this.$t("objects.contract.customer.BillingTypeEnum.flat_rate"),
        value: ContractBillingTypeEnum.FLAT_RATE
      },
      { text: this.$t("objects.contract.customer.BillingTypeEnum.monthly"), value: ContractBillingTypeEnum.MONTHLY },
      {
        text: this.$t("objects.contract.customer.BillingTypeEnum.quarterly"),
        value: ContractBillingTypeEnum.QUARTERLY
      },
      {
        text: this.$t("objects.contract.customer.BillingTypeEnum.semiannual"),
        value: ContractBillingTypeEnum.SEMIANNUAL
      },
      { text: this.$t("objects.contract.customer.BillingTypeEnum.annual"), value: ContractBillingTypeEnum.ANNUAL }
    ];
  }

  get billingModeItems() {
    return [
      { text: this.$t("objects.contract.customer.BillingModeEnum.Individual"), value: BillingModeEnum.Individual },
      { text: this.$t("objects.contract.customer.BillingModeEnum.Collective"), value: BillingModeEnum.Collective }
    ];
  }
}
